import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErrorDialogComponentBase } from '../../error-dialog-component-base';

@Component({
  standalone: false,
  templateUrl: './response-error.dialog.component.html'
})

export class ResponseErrorDialogComponent extends ErrorDialogComponentBase {

  private supportedResponseCodes = [404];
  public useResponseCode: boolean;
  public responseCode: boolean;
  public message: string;

  constructor(
    public dialogRef: MatDialogRef<ResponseErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    super(true);

    if (data) {
      this.fill(data.error);
    }
  }

  private fill(error: any) {

    if (!error) {
      return;
    }

    if (error.status) {
      this.useResponseCode =
        this.supportedResponseCodes.includes(error.status);
      this.responseCode = error.status;
    }

  }

}
